export const INPUT_HEIGHT = 45;

export const MIN_DNS_ALIAS_LENGTH = 3;
